import { Route } from '@angular/router'

import { LayoutOptions } from '@flowx/designer/shared/types/layout.types'

import { ApplicationResourcesRoutes } from './application-resources-routes'
import { ApplicationRuntimeRoutes } from './application-runtime-routes'

export const ApplicationMainLayoutRoutes: Route[] = [
  {
    path: 'config/:appVersionId',
    data: { routeKey: 'config', [LayoutOptions.HAS_FOOTER]: true },
    children: ApplicationResourcesRoutes,
  },
  {
    path: 'runtime',
    loadComponent: () =>
      import('./components/runtime-main-layout/runtime-main-layout.component').then(
        ({ RuntimeMainLayoutComponent }) => RuntimeMainLayoutComponent
      ),
    children: ApplicationRuntimeRoutes,
  },
]
